
import React from 'react';
import './SuperAdminDashboard.css';

const AdminStats = ({ stats }) => {
    return (
        <div className="admin-stats-grid">
            <div className="stat-card blue-gradient">
                <div className="stat-icon"><i className="fa fa-users"></i></div>
                <div className="stat-details">
                    <h3>{stats?.total_users || 0}</h3>
                    <p>Total Users</p>
                </div>
            </div>
            <div className="stat-card purple-gradient">
                <div className="stat-icon"><i className="fa fa-building"></i></div>
                <div className="stat-details">
                    <h3>{stats?.total_companies || 0}</h3>
                    <p>Total Companies</p>
                </div>
            </div>
            <div className="stat-card green-gradient">
                <div className="stat-icon"><i className="fa fa-check-circle"></i></div>
                <div className="stat-details">
                    <h3>{stats?.active_users || 0}</h3>
                    <p>Active Users</p>
                </div>
            </div>
            <div className="stat-card orange-gradient">
                <div className="stat-icon"><i className="fa fa-user-plus"></i></div>
                <div className="stat-details">
                    <h3>{stats?.new_signups || 0}</h3>
                    <p>New Signups (7d)</p>
                </div>
            </div>
        </div>
    );
};

export default AdminStats;
